// 将数组转对象，并把下标设为a,b,c,d....
export function arrayToObject(arr) {
  return arr.reduce((obj, item, index) => {
    const key = String.fromCharCode(97 + index); //97是a 转换为 a,b,c,d,e这样的字符
    obj[key] = item;
    return obj;
  }, {});
}

/**
 * 打开全屏
 */
export function fullScreen (dom) {
    var el = document.querySelector(dom) || document.documentElement;
    var rfs = el.requestFullScreen || el.webkitRequestFullScreen;
    if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
    } else if (typeof window.ActiveXObject != "undefined") {      //这里本意是对IE的全屏活动做适配
        var wscript = new ActiveXObject("WScript.Shell");      //调用IE浏览器工具
        if (wscript != null) {        //如果本地程序不存在，则对ie执行f11全屏事件
            wscript.SendKeys("{F11}");
        }
    } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen();
    } else if (el.oRequestFullscreen) {
        el.oRequestFullscreen();
    } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
    } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
    } else {
        alert('浏览器不支持全屏调用！')
    }
}

/**
 * 退出全屏
 */
export function exitFullScreen () {
    var el = document;
    var cfs = el.cancelFullScreen || el.webkitCancelFullScreen || el.exitFullScreen;
    if (typeof cfs != "undefined" && cfs) {
        cfs.call(el);
    } else if (typeof window.ActiveXObject != "undefined") {
        var wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
            wscript.SendKeys("{F11}");
        }
    } else if (el.msExitFullscreen) {
        el.msExitFullscreen();
    } else if (el.oRequestFullscreen) {
        el.oCancelFullScreen();
    }else if (el.mozCancelFullScreen) {
        el.mozCancelFullScreen();
    } else if (el.webkitCancelFullScreen) {
        el.webkitCancelFullScreen();
    } else {
       alert('浏览器不支持全屏调用！')
    }
}

export function fullListen(dom){
  let screen = document.querySelector('#fullID') || document.body
  console.log(5000,screen)
  if(screen.requestFullscreen){
    console.log(1000,screen.requestFullscreen)
    document.addEventListener("fullscreenchange",()=>{
      console.log(2000,screen)
      if(getFullscreenElement()== null){
        return false;
      }
    })
  }
}
export function getFullscreenElement(){
  console.log(5111,document)
  return (
    document['fullscreenElement']||
    document['mozFullScreenelement']||
    document['msFullscreenElement']||
    document['webkitFullscreenElement']||null
  )
  // return (
  //   document.fullscreenElement||
  //   document.mozFullScreenelement||
  //   document.msFullscreenElement||
  //   document.webkitFullscreenElement||null
  // )
}
export function checkFull() {
    var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
    //to fix : false || undefined == undefined
    if (isFull === undefined) {isFull = false;}
    return isFull;
}



// WEBPACK FOOTER //
// ./src/utils/tool.js